module.exports = __webpack_public_path__ + "img/chr_ts_2_penlight.ec42fe1b.png";